var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-validation",style:(`font-size: ${_vm.size}; `)},[(_vm.status)?_c('i',{staticClass:"fas fa-check",attrs:{"success":""}}):_vm._e(),(!_vm.status && _vm.status != undefined)?_c('i',{staticClass:"far fa-times-circle",attrs:{"danger":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }